var weather_icons = {
    0: 'wi-tornado',
    1: 'wi-hurricane',
    2: 'wi-hurricane',
    3: 'wi-thunderstorm',
    4: 'wi-thunderstorm',
    5: 'wi-rain-mix',
    6: 'wi-rain-mix',
    7: 'wi-snow',
    8: 'wi-rain',
    9: 'wi-rain',
    10: 'wi-hail',
    11: 'wi-showers',
    12: 'wi-showers',
    13: 'wi-snow',
    14: 'wi-snow',
    15: 'wi-snow-wind',
    16: 'wi-snow',
    17: 'wi-hail',
    18: 'wi-sleet',
    19: 'wi-dust',
    20: 'wi-fog',
    21: 'wi-day-haze',
    22: 'wi-smoke',
    23: 'wi-strong-wind',
    24: 'wi-windy',
    25: 'wi-snowflake-cold',
    26: 'wi-cloud',
    27: 'wi-night-alt-cloudy',
    28: 'wi-day-cloudy',
    29: 'wi-night-alt-partly-cloudy',
    30: 'wi-day-cloudy-high',
    31: 'wi-night-clear',
    32: 'wi-day-sunny',
    33: 'wi-night-clear',
    34: 'wi-day-sunny',
    35: 'wi-rain-mix',
    36: 'wi-hot',
    37: 'wi-storm-showers',
    38: 'wi-thunderstorm',
    39: 'wi-thunderstorm',
    40: 'wi-showers',
    41: 'wi-snow-wind',
    42: 'wi-day-snow-thunderstorm',
    43: 'wi-snow-wind',
    44: 'wi-cloud',
    45: 'wi-thunderstorm',
    46: 'wi-day-snow-thunderstorm',
    47: 'wi-thunderstorm',
    3200: ''
};

$(document).ready(function () {
    if ($('#weather-widget').length) {
        $('.weather-container').find('#weather-refresh').on('click', function () {
            update_weather($(this));
        });

        var top_nav = $('#top-nav');

        top_nav.find('.dropdown.weather .dropdown-menu').on('click', function (e) {
            e.stopPropagation();
        });

        top_nav.find('.dropdown.weather').on('show.bs.dropdown', function () {
            update_weather($(this).closest('.dropdown').find('#weather-refresh'));
        });
    }
});

var update_weather = function (el) {
    var weather_container = el.closest('.weather-container');
    weather_container.find('.error-row').hide();
    weather_container.find('#weather-refresh i').attr('class', 'fa fa-refresh fa-spin');
    var zip = weather_container.find('.weather-zip').val();
    $.simpleWeather({
        location: zip,
        woeid: '',
        unit: 'f',
        success: function (weather) {
            updated = moment(weather.updated, 'ddd, D MMM YYY h:mm a').format('h:mmA').slice(0, -1);
            weather_container.find('.header-row .time').html(weather.city + ', ' + weather.region + ' at ' + updated);

            sunrise = moment(weather.sunrise, 'h:mm A').format('h:mma').slice(0, -1);
            sunset = moment(weather.sunset, 'h:mm A').format('h:mma').slice(0, -1);
            weather_container.find('div.currently span.temperature').html(weather.temp);
            weather_container.find('div.currently span.heat-index').html(Number((weather.heatindex)).toFixed(2));
            weather_container.find('div.currently span.humidity').html(weather.humidity);
            weather_container.find('div.currently span.sunrise').html(sunrise);
            weather_container.find('div.currently span.sunset').html(sunset);
            weather_container.find('div.currently i.condition').attr('class', 'wi fa-fw condition ' + weather_icons[weather.code])
                .attr('title', weather.currently).tooltip('fixTitle');

            $.each(weather.forecast, function (index, value) {
                if (index == 0) {
                    date = 'Today';
                } else {
                    date = moment(value.date, 'D MMM YYYY').format('ddd');
                    if (index > 6) {
                        date = 'N. ' + date;
                    }
                }

                day_container = weather_container.find('div.day-' + index);
                day_container.find('div.date').html(date);
                day_container.find('i.condition').attr('class', 'wi fa-fw condition ' + weather_icons[value.code])
                    .attr('title', value.text).tooltip('fixTitle');
                day_container.find('div.high span').html(value.high);
                day_container.find('div.low span').html(value.low);
            });
            weather_container.find('#weather-refresh i').attr('class', 'fa fa-search');
        },
        error: function (error) {
            weather_container.find('.error-row .alert').html(error);
            weather_container.find('.error-row').show();
            weather_container.find('#weather-refresh i').attr('class', 'fa fa-search');
        }
    });
}
